// Older server-generated text (stored notification messages, Glove Box document names
// such as "Diagnostic Report — Car won't start (#1287)") uses em dashes. New text no
// longer does; this keeps already-stored rows consistent on screen without rewriting data.
export function withoutEmDashes(text) {
    if (typeof text !== 'string' || !text.includes('—')) return text;
    return text
        .replace(/\s+—\s+/g, ': ')
        .replace(/—/g, '-');
}

// Product wording: what used to be called a "Diagnostic Report" is shown to drivers as a
// "Symptom Report". This relabels ONLY the user-visible text at render time — internal
// constants, trigger messages, matchers and backend protocol keep the original wording,
// so nothing in the diagnostic flow breaks. Case of the original "diagnostic" is preserved
// (DIAGNOSTIC/Diagnostic/diagnostic -> SYMPTOM/Symptom/symptom).
export function relabelReport(text) {
    if (typeof text !== 'string' || !/diagnostic report/i.test(text)) return text;
    return text.replace(/diagnostic(?=\s+report)/gi, (match) => {
        if (match === match.toUpperCase()) return 'SYMPTOM';
        if (match[0] === match[0].toUpperCase()) return 'Symptom';
        return 'symptom';
    });
}

// Convenience: apply both transforms (em-dash cleanup + report relabel).
export function displayMessageText(text) {
    return relabelReport(withoutEmDashes(text));
}
